<template>
  <div class="cmdetzw">
    <div class="cmddetfiletop">
      <div class="filetoptitle">{{hdinfo.title}}</div>
      <div class="filecennum flex_start">
        <div>共{{hdinfo.page_num}}页</div>
        <div>{{hdinfo.view_num}}次浏览</div>
        <div>{{hdinfo.download_num}}次下载</div>
        <div>
          <img src="../../../assets/contmodeldet/docsicon.png" alt="" />.docx
        </div>
      </div>
      <div class="fileprice">价格：<span>¥{{hdinfo.price}}</span></div>
      <div class="filesm">
        使用说明：本文本适用于商标异议申请，包含商标异议申请书、商标异议理由书、证据清单三个部分。
      </div>
      <div class="flex_start">
        <div class="filebtn btn1 mr20">下载文档</div>
        <div class="filebtn btn2">
          <img src="../../../assets/contmodeldet/shoucang0.png" alt="" />收藏
        </div>
      </div>
    </div>
    <div class="cdetfilecont mt30">
      <div class="nr">
        <div>{{hdinfo.title}}</div>
        <div class="mt10">
          <img :src="hdinfo.preview_pic" />
        </div>
      </div>
      <div class="download between">
        <div class="flex_start">
          <div>
            <img src="../../../assets/contmodeldet/docsicon1.png" />
          </div>
          <div class="filetext">
            <div class="tit">商标异议申请书</div>
            <div class="des">
              Word A4打印 标准格式 可随意修改
              <span>一次下载，永久使用，无水印</span>
            </div>
          </div>
        </div>
        <div class="dldbtn">下载文档</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    hdartId: null,
    hdinfo:{}
  }),
  beforeMount() {
    this.hdartId = this.$route.query.hdartId
    this.gethdinfo()
  },
  methods: {
    gethdinfo() {
      let data = {
        id: this.hdartId,
      };
      this.$http.jpcol
        .getcontractcontent(data)
        .then((res) => {
          this.hdinfo = res.data
        })
    },
  },
};
</script>
<style lang="scss" scoped>
.cmdetzw {
  .cmddetfiletop {
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 2px;
    padding: 30px 22px;
    .filetoptitle {
      font-size: 28px;
      color: #333333;
      line-height: 28px;
    }
    .filecennum {
      margin-top: 20px;
      font-size: 14px;
      color: #666666;
      line-height: 14px;
      div {
        margin-right: 25px;
        padding-right: 25px;
        border-right: 1px solid #e8e8e8;
        &:last-child {
          border: none;
        }
      }
    }
    .fileprice {
      margin-top: 20px;
      font-size: 14px;
      color: #666666;
      line-height: 14px;
      span {
        color: #ec3b3b;
        font-size: 18px;
      }
    }
    .filesm {
      margin-top: 24px;
      font-size: 14px;
      color: #666666;
      line-height: 14px;
    }
    .filebtn {
      width: 120px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      border-radius: 18px;
      font-size: 16px;
      margin-top: 26px;
      img {
        width: 16px;
        margin-right: 8px;
        vertical-align: -0.1em;
      }
      &.btn1 {
        color: #ffffff;
        background: #f25619;
      }
      &.btn2 {
        color: #f25618;
        background: #ffffff;
        border: 1px solid #f25619;
      }
    }
  }
  .cdetfilecont {
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 2px;
    .nr {
      padding: 50px 0;
      text-align: center;
      font-size: 34px;
      font-weight: bold;
      color: #333333;
      line-height: 34px;
    }
    .download {
      padding: 22px 62px;

      position: sticky;
      background: #fff;
      width: 856px;
      bottom: 0;
      border-top: 3px solid #f8f8f8;
      img {
        width: 42px;
        height: 44px;
      }
      .filetext {
        margin-left: 15px;
      }
      .tit {
        font-size: 22px;
        color: #333333;
        line-height: 22px;
      }
      .des {
        margin-top: 8px;
        font-size: 12px;
        color: #999999;
        line-height: 12px;
        span {
          color: #ec3b3b;
          margin-left: 20px;
        }
      }
      .dldbtn {
        cursor: pointer;
        width: 120px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        border-radius: 18px;
        font-size: 16px;
        color: #ffffff;
        background: #f25619;
      }
    }
  }
}
</style>